import React, { useState } from "react";

const SuggestionActionList = ({ suggestions, onSuggestionClick,isArabic,locked=false }) => {
  const [showAll, setShowAll] = useState(false);
  console.log('Suggestions Clean',suggestions)

  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  const visibleSuggestions = showAll ? suggestions : suggestions.slice(0, 4);
  const isMobile = window.innerWidth <= 1000;  // Check if the screen size is mobile

  const fontSize = isMobile ? '0.8rem' : '0.9rem'; // Adjust as needed
  return (
    <div>
      <div className={`suggestion-list flex flex-wrap gap-2 mt-1 mb-0 ${isArabic ? 'justify-end' : 'justify-start'}`} style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      {visibleSuggestions.map((suggestion, index) => {
  const getLocalizedText = (text) => {
    const parts = text.split("|||");
    if (parts.length === 1) {
      return parts[0]; // If there's only one part, return it
    }
    return isArabic ? parts[1] : parts[0]; // Return based on the language
  };

  return (
    <div
      key={index}
      className="border border-[#007560] rounded-lg px-4 py-2 text-[#007560] text-center cursor-pointer hover:bg-[#f0fdf9] flex items-center"
      style={{ fontSize }}
      onClick={() =>  {if (!locked) {
        onSuggestionClick(getLocalizedText(String(suggestion.value)));
      }}}
    >
      {getLocalizedText(suggestion.title)}
    </div>
  );
})}
        {suggestions.length > 4 && (
          <div
            onClick={() => setShowAll(!showAll)}
            className="border border-[#007560] rounded-lg px-4 py-2 text-[#007560] text-center cursor-pointer hover:bg-[#f0fdf9] flex items-center"
            style={{ fontSize: "0.9rem" }}
          >
            {showAll ? "<" : ">"}
          </div>
        )}
      </div>
    </div>
  );
};

export default SuggestionActionList;
